<template>
  <label
    :class="[
      isDisabled
        ? 'cursor-not-allowed opacity-70'
        : 'hover:bg-primary/70',
      'relative inline-flex cursor-pointer items-center rounded-lg border border-background bg-primary px-3 py-1 text-sm font-medium text-primary-fg focus:z-10 focus:outline-none',
    ]"
  >
    <slot> Upload </slot>
    <input
      :disabled="isDisabled"
      type="file"
      accept=".csv,.xlsx"
      hidden
      @change="onFileInputChange"
    />
  </label>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    isDisabled?: boolean
  }>(),
  { isDisabled: false }
)
const emit = defineEmits<{
  (event: "upload", value: File): void
}>()

const onFileInputChange = (event: Event) => {
  const target = event.target as HTMLInputElement
  const file = target?.files?.[0]
  if (!file) return
  emit("upload", file)
  target.value = ""
}
</script>
